module.exports = __webpack_public_path__ + "img/21.c143a36.jpg";